import React, { useState } from 'react';
import _ from 'lodash';
import { ClickAwayListener } from '@material-ui/core';
import { MenuList, MenuItem as MaterialMenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import DropDown from 'src/components/DropDown/DropDown';
import Icon from 'src/components/Icon/Icon';

interface DropdownProps {
  dataList: any,
  type: string;
  setType: any;
  translation?: boolean;
}

export default function Dropdown({ dataList, type, setType, translation = true }: DropdownProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const selectedItem = _.find(dataList, { value: type });

  const selectType = (typeName) => (e) => {
    e.preventDefault();
    setOpen(false);
    setType(typeName);
  };

  return (
    <>
      <ClickAwayListener onClickAway={ () => setOpen(false) }>
        <div className="statement__dropdown">
          <Icon icon="filter" className="statement__icon" />
          <DropDown
            value={ <div>{ translation ? t(`accountHistory.${ type }`) : selectedItem?.label }</div> }
            openMenu={ () => setOpen(!open) }
            open={ open }
          >
            {
              _.map(dataList, item => (
                <MenuList
                  key={ item.label }
                  className="top-menu__sub-menu"
                  autoFocusItem={ true }
                >
                  <MaterialMenuItem
                    className="top-menu__sub-menu__item"
                    onClick={ selectType(item.value) }
                  >
                    { translation ? t(`accountHistory.${ item.value }`) : item.label }
                  </MaterialMenuItem>
                </MenuList>
              ))
            }
          </DropDown>
        </div>
      </ClickAwayListener>
    </>
  );
}
